import { useContext } from 'react';
import { AuthContext, AuthContextType } from '../contexts/AuthContext';

function useAuth() {
  const context = useContext(AuthContext);

  if (context === null) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  if (context.user === null) {
    throw new Error('useAuth must be used within authenticated content');
  }

  return context as AuthContextType & { user: NonNullable<AuthContextType['user']> };
}

export default useAuth;
